var map = {
	"./Spin_TG-Derecha_001.webp": 55610,
	"./Spin_TG-Derecha_002.webp": 22727,
	"./Spin_TG-Derecha_003.webp": 15720,
	"./Spin_TG-Derecha_004.webp": 48201,
	"./Spin_TG-Derecha_005.webp": 90389,
	"./Spin_TG-Derecha_006.webp": 47944,
	"./Spin_TG-Derecha_007.webp": 54581,
	"./Spin_TG-Derecha_008.webp": 55435,
	"./Spin_TG-Derecha_009.webp": 36738,
	"./Spin_TG-Derecha_010.webp": 84656,
	"./Spin_TG-Derecha_011.webp": 51605,
	"./Spin_TG-Derecha_012.webp": 34821,
	"./Spin_TG-Derecha_013.webp": 99869,
	"./Spin_TG-Derecha_014.webp": 4647,
	"./Spin_TG-Derecha_015.webp": 50630,
	"./Spin_TG-Derecha_016.webp": 15287,
	"./Spin_TG-Derecha_017.webp": 66241,
	"./Spin_TG-Derecha_018.webp": 75458,
	"./Spin_TG-Derecha_019.webp": 37587,
	"./Spin_TG-Derecha_020.webp": 15660,
	"./Spin_TG-Derecha_021.webp": 47046,
	"./Spin_TG-Derecha_022.webp": 96859,
	"./Spin_TG-Derecha_023.webp": 13707,
	"./Spin_TG-Derecha_024.webp": 71466,
	"./Spin_TG-Derecha_025.webp": 78182,
	"./Spin_TG-Derecha_026.webp": 66934,
	"./Spin_TG-Derecha_027.webp": 67064,
	"./Spin_TG-Derecha_028.webp": 91194,
	"./Spin_TG-Derecha_029.webp": 50243,
	"./Spin_TG-Derecha_030.webp": 90029,
	"./Spin_TG-Derecha_031.webp": 91650,
	"./Spin_TG-Derecha_032.webp": 6633,
	"./Spin_TG-Derecha_033.webp": 90154,
	"./Spin_TG-Derecha_034.webp": 16572,
	"./Spin_TG-Derecha_035.webp": 49886,
	"./Spin_TG-Derecha_036.webp": 91465,
	"./Spin_TG-Derecha_037.webp": 2998,
	"./Spin_TG-Derecha_038.webp": 34895,
	"./Spin_TG-Derecha_039.webp": 82855,
	"./Spin_TG-Derecha_040.webp": 55142,
	"./Spin_TG-Derecha_041.webp": 70068,
	"./Spin_TG-Derecha_042.webp": 36746,
	"./Spin_TG-Derecha_043.webp": 42528,
	"./Spin_TG-Derecha_044.webp": 62574,
	"./Spin_TG-Derecha_045.webp": 72536,
	"./Spin_TG-Derecha_046.webp": 45458,
	"./Spin_TG-Derecha_047.webp": 89349,
	"./Spin_TG-Derecha_048.webp": 66447,
	"./Spin_TG-Derecha_049.webp": 39271,
	"./Spin_TG-Derecha_050.webp": 90171,
	"./Spin_TG-Derecha_051.webp": 51277,
	"./Spin_TG-Derecha_052.webp": 91526,
	"./Spin_TG-Derecha_053.webp": 45966,
	"./Spin_TG-Derecha_054.webp": 64591,
	"./Spin_TG-Derecha_055.webp": 55355,
	"./Spin_TG-Derecha_056.webp": 69551,
	"./Spin_TG-Derecha_057.webp": 92834,
	"./Spin_TG-Derecha_058.webp": 96321,
	"./Spin_TG-Derecha_059.webp": 79995,
	"./Spin_TG-Derecha_060.webp": 90066,
	"./Spin_TG-Derecha_061.webp": 35282,
	"./Spin_TG-Derecha_062.webp": 91238,
	"./Spin_TG-Derecha_063.webp": 30748,
	"./Spin_TG-Derecha_064.webp": 68530,
	"./Spin_TG-Derecha_065.webp": 79525,
	"./Spin_TG-Derecha_066.webp": 67356,
	"./Spin_TG-Derecha_067.webp": 23626,
	"./Spin_TG-Derecha_068.webp": 48626,
	"./Spin_TG-Derecha_069.webp": 92605,
	"./Spin_TG-Derecha_070.webp": 47569,
	"./Spin_TG-Derecha_071.webp": 66474,
	"./Spin_TG-Derecha_072.webp": 266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12434;